export default __webpack_public_path__ + "static/media/fmPlaceholder.424c086b.png";